//general mutations
export const SET_API = "SET_API_SINGLETON";
export const SET_PERIOD = "SET_PERIOD";
export const SET_PERIOD_TEMP = "SET_PERIOD_TEMP";
export const SET_PERIODS = "SET_PERIODS";
export const SET_STORAGE = "SET_STORAGE";
export const SET_HEIGHT = "SET_HEIGHT";
export const SET_WIDTH = "SET_WIDTH";
export const RESET_STATE = "RESET_STATE";
export const SET_RELATIVE_READY = "SET_RELATIVE_READY";
export const UPDATE_INVOICE_REQUIRED = "UPDATE_INVOICE_REQUIRED";

export const SET_USER_LOCAL = "SET_USER_LOCAL";

//menu module
export const TOGGLE_MENU = "TOGGLE_MENU";

//user module
export const SET_TOKEN = "SET_TOKEN";
export const SET_USER = "SET_USER";
export const SET_CAMPUS_OBJECT = "SET_CAMPUS_OBJECT";
export const SET_AUTHSTATE = "SET_AUTHSTATE";
export const SET_EXPTOKEN = "SET_EXPTOKEN";
export const SET_CAMPUS = "SET_CAMPUS";
export const SET_PARAMS = "SET_PARAMS";
export const SET_AUTH_STATUS = "SET_AUTH_STATUS";
export const CLEAR_TOKEN = "CLEAR_TOKEN";

//FOLLOWUP SECTION
export const SEARCH_TERMS = "SEARCH_TERMS";
export const APPLY_FILTERS = "APPLY_FILTERS";
export const OVERWRITE_CLASES = "OVERWRITE_CLASES";
export const OVERWRITE_GROUPS = "OVERWRITE_GROUPS";
export const SET_CLASES = "SET_CLASES";
export const SET_GROUPS = "SET_GROUPS";
export const SET_GROUPS_CHALLENGE = "SET_GROUPS_WITH_CHALLENGES";
export const SET_GROUPS_PERIOD = "SET_GROUPS_WITH_PERIODS";
export const SET_BOLETA = "SET_BOLETA";
export const SET_BOLETA_PERSONAL = "SET_BOLETA_PERSONAL";
export const EDIT_SCORE = "EDIT_SCORE";
export const REVERT_SCORE = "REVERT_SCORE";
export const CLEAR_SELECTION = "CLEAR_SELECTION";
export const ADD_SELECTION = "ADD_SELECTION";
export const REMOVE_SELECTION = "REMOVE_SELECTION";
export const SET_SELECTION = "SET_SELECTION";
export const ADD_REFRESH_ITEM = "ADD_REFRESH_ITEM";
export const REMOVE_REFRESH_ITEM = "REMOVE_REFRESH_ITEM";
export const UPDATE_GROUP_REPORT_CALCULATION =
  "UPDATE_GROUP_REPORT_CALCULATION";

//Filter Component
export const SET_FILTERS = "SET_FILTERS";
export const UPDATE_FILTERS = "UPDATE_FILTERS";
export const SET_STORAGE_FILTERS = "SET_STORAGE_FILTERS";
export const SET_STORAGE_NAME_FILTERS = "SET_STORAGE_NAME_FILTERS";
export const SET_MULTI_FILTERS = "SET_MULTI_FILTERS";
export const HIDE_FILTER = "HIDE_FILTER";
export const SHOW_FILTER = "SHOW_FILTER";
export const SET_FILTERS_SELECTION = "SET_FILTERS_SELECTION";
export const CLEAR_FILTER_SELECTION = "CLEAR_FILTER_SELECTION";
export const ADD_FILTER_SELECTION = "ADD_FILTER_SELECTION";
export const REMOVE_FILTER_SELECTION = "REMOVE_FILTER_SELECTION";

//Webon Table Component
export const WT_INIT = "INITIALIZE_PROPERTIES";
export const WT_SET_DATA = "SET_DATA";
export const WT_SET_TOTALRECORDS = "SET_TOTAL_RECORDS";
export const WT_SET_PAGES = "SET_TOTAL_PAGES";
export const WT_SET_PAGINATION = "SET_PAGINATION";
export const WT_CHANGE_PAGE = "SET_PAGE";
export const WT_UPDATE_EXTERNAL_PARAMETERS = "UPDATE_EXTERNAL_PARAMETERS";
export const WT_CHANGE_PAGE_SIZE = "CHANGE_PAGE_SIZE";
export const WT_SET_SORT = "SET_SORTNAME";
export const WT_SET_SEARCHKEY = "SET_SEARCH_KEY";
export const WT_SELECT_ALL = "SELECT_ALL_ROWS";
export const WT_SELECT_ROW = "SELECT_ROW";
export const WT_UPDATE_DRAW = "UPDATE_DRAW_LIST";
export const WT_RESET_SELECTION = "WT_RESET_SELECTION";
export const WT_SET_SELECTION = "WT_SET_SELECTION";
export const WT_DISABLED_REQUEST_UPDATED = "WT_DISABLED_REQUEST_UPDATED";
export const WT_EVENT_EMITTED = "WT_EVENT_EMITTED";

//Classes
export const SET_CLASS = "SET_CLASS";
export const UPDATE_CLASS = "UPDATE_CLASS";
export const REMOVE_STUDENTS = "REMOVE_STUDENTS";
export const ADD_STUDENTS = "ADD_STUDENTS";

//Evaluation Model
export const ADD_CLASSES = "ADD_CLASSES";
export const ADD_CRITERIAS = "ADD_CRITERIAS";
export const UPDATE_MODEL = "UPDATE_MODEL";
export const REMOVE_ICRITERIAS = "REMOVE_ICRITERIAS";
export const REMOVE_CLASSES = "REMOVE_CLASSES";
export const SET_MODEL = "SET_MODEL";

//groups
export const UPDATE_GROUP = "UPDATE_GROUP";
export const SET_GROUP = "SET_GROUP";

//Visibility configuration
export const SET_LEVELS = "SET_LEVELS";
export const CHANGE_GROUP = "CHANGE_GROUP";
export const CHANGE_GRADE = "CHANGE_GRADE";
export const CHANGE_LEVEL = "CHANGE_LEVEL";
export const CHANGE_SET_PERIOD = "CHANGE_SET_PERIOD";

//Viewer
export const SET_RESOURCE = "SET_RESOURCE";

//Students Form
export const ADD_STUDENT = "ADD_STUDENT";
export const REMOVE_STUDENT = "REMOVE_STUDENT";
export const CLEAR_STUDENTS = "CLEAR_STUDENTS";

//Grade Report (Boleta individual)
export const SET_STUDENTS_LIST = "SET_STUDENTS_LIST";
export const SET_CHALLENGES_LIST = "SET_CHALLENGES_LIST";
export const SET_SCORES_LIST = "SET_SCORES_LIST";
export const SET_PERIODS_LIST = "SET_PERIODS_LIST";
export const SET_OFFICIAL_SCORES_LIST = "SET_OFFICIAL_SCORES_LIST";
export const CLEAR_SCORES = "CLEAR_SCORES";

//Call Center
export const SET_DASHBOARD_INFORMATION = "SET_DASHBOARD_INFORMATION";

export const SET_EXPANDED = "SET_EXPANDED";
